import { h, Fragment } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';

import { getOptionsBank } from '../../../controllers/OptionsController';

import * as OptionController from '../../../controllers/OptionsController';

import { GlobalState } from '../../../states/global-state';
import { KycProps } from '../../../constants/kyc';
import { useSignal, useSignalEffect } from '@preact/signals';
import { showSpinner, hideSpinner } from '../../../utils';

type BankSelectProps = {
  bank: {
    name: string;
    label: string;
    options?: [];
    validator?: string;
    optionCategory?: string;
    remoteOption?: boolean;
    optionGetter?: string;
  };
  branch: {
    name: string;
    label: string;
    options?: [];
    validator?: string;
    optionCategory?: string;
    remoteOption?: boolean;
    optionGetter?: string;
  };
};

const BankSelect = props => {
  const formControls = useRef(props.controls as BankSelectProps);

  const [optionsBank, setBankOptions] = useState([]);
  const [optionsBranch, setBranchOptions] = useState([]);

  const currentKycLoad = useRef({});

  const loadedKyc = useSignal(false);

  const loadedBank = useSignal(false);
  const loadedBranch = useSignal(false);
  const selectedBank: any = useSignal('');
  const selectedBranch: any = useSignal('');

  const getBanks = async controls => {
    showSpinner();
    const options = await OptionController[controls.bank.optionGetter]({
      category: controls.bank.optionCategory,
    });

    if (options) {
      setBankOptions(options);
      setTimeout(() => {
        loadedBank.value = true;
      }, 500);
    }
  };
  const getBranch = async controls => {
    const options = await OptionController[controls.branch.optionGetter]({
      category: controls.branch.optionCategory,
    });

    if (options) {
      setBranchOptions(options);
      setTimeout(() => {
        loadedBranch.value = true;
      }, 500);
    }
  };

  useSignalEffect(() => {
    const settlementLoad = GlobalState.settlementLoad.value;

    currentKycLoad.current = settlementLoad;
    if (Object.keys(settlementLoad).length) {
      loadedKyc.value = true;

      loadedBank.value &&
        (selectedBank.value = settlementLoad[formControls.current.bank.name]);
      loadedBranch.value &&
        (selectedBranch.value =
          settlementLoad[formControls.current.branch.name]);
    }
    if (loadedKyc.value) {
      getBanks(formControls.current);
    }

    if (loadedKyc.value) {
      getBranch(formControls.current);
    }

    if (loadedKyc.value && loadedBank.value && loadedBranch.value) {
      hideSpinner();
    }
  });

  const changeBankHandler = e => {
    selectedBank.value = e.target.value;
  };

  const changeBranchHandler = e => {
    selectedBranch.value = e.target.value;
  };

  return (
    <Fragment>
      <div class="form-floating mb-3 form-group" key={crypto.randomUUID()}>
        <select
          class="form-select input"
          id={formControls.current.bank.name}
          name={formControls.current.bank.name}
          data-validator={formControls.current.bank.validator || ''}
          value={selectedBank}
          onChange={changeBankHandler}
        >
          {optionsBank.map(item => {
            return (
              <option value={item.code} key={item.key}>
                {item.value}
              </option>
            );
          })}
        </select>
        <label for={formControls.current.bank.name}>
          {formControls.current.bank.label}
        </label>
      </div>
      <div class="form-floating mb-3 form-group" key={crypto.randomUUID()}>
        <select
          class="form-select input"
          id={formControls.current.branch.name}
          name={formControls.current.branch.name}
          data-validator={formControls.current.branch.validator || ''}
          value={selectedBranch}
          onChange={changeBranchHandler}
        >
          {optionsBranch.map(item => {
            return (
              <option value={item.code} key={item.key}>
                {item.value}
              </option>
            );
          })}
        </select>
        <label for={formControls.current.branch.name}>
          {formControls.current.branch.label}
        </label>
      </div>
    </Fragment>
  );
};

export default BankSelect;
